import moment from "moment";
import axios from "axios";
import "./FilterCalendar.css";
import Select from 'react-select';
import "rsuite/dist/rsuite.min.css";
import getCurrencyByCode from 'currency-codes';
import "react-toastify/dist/ReactToastify.css";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFetchDashboardCurrency } from "./DashboardCurrencyApi";
import { setDashboardDate, setDashboardCurrencyRx, setDashboardCurrencySum } from "../../features/invoice/invoiceSlice";
import { setForex } from "../../features/forex/forexSlice.js";
import Calendar from "../../helpers/dateComponents/Calendar";
import { setAppLoading } from "../../features/appSettings/appSettingsSlice.js";

export default function FilterCalendar() {

  const dispatch = useDispatch();
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  const [allCurrency, setAllCurrency] = useState(true);
  const dashboradCurrency = useSelector((state) => state.invoice.dashboardCurrency);
  const dashboardCurrencySum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const { appSettings } = useSelector((state) => state.appSettings);
  const calendarRef = useRef(null);
  const [selectedCurrency, setSelectedCurrency] = useState(dashboradCurrency);
  const [selDashboardCurrency, setSelDashboardCurrency] = useState("");
  const [selectedForex, setSelectedForex] = useState([]);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDateChange = async (ranges) => {
    try {
      const dateRangeArray = [ranges.startDate, ranges.endDate];
      setSelectedRange(dateRangeArray);

      await dispatch(setDashboardDate(dateRangeArray));

      setShowCalendar(false);
    } catch (error) {
      console.error("Error updating date range:", error);
      // Optional: Show user-friendly notification
      alert("Failed to update date range. Please try again.");
      // Optionally keep calendar open to let user retry
    }
  };

  const toggleCalendar = () => {
    setShowCalendar((prev) => {
      const next = !prev;
      if (next && typeof window !== "undefined" && window.innerWidth <= 991) {
        const anchor = calendarRef.current;
        if (anchor) {
          const rect = anchor.getBoundingClientRect();
          document.documentElement.style.setProperty(
            "--mobile-calendar-top",
            `${Math.round(rect.bottom + 8)}px`
          );
        }
      }
      return next;
    });
  };

  const cancelCalendar = () => {
    setShowCalendar(false);
  };

  useEffect(() => {
    if (!showCalendar || !isMobile) return undefined;
    const updateTop = () => {
      const anchor = calendarRef.current;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      document.documentElement.style.setProperty(
        "--mobile-calendar-top",
        `${Math.round(rect.bottom + 8)}px`
      );
    };
    updateTop();
    window.addEventListener("resize", updateTop);
    window.addEventListener("scroll", updateTop, true);
    return () => {
      window.removeEventListener("resize", updateTop);
      window.removeEventListener("scroll", updateTop, true);
    };
  }, [showCalendar, isMobile]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      border: '0.2px solid rgba(106, 121, 136, 0.7)',
      borderRadius: '6px',
      padding: '8px 16px',
      fontSize: '17px',
      width: '251px',
      color: '#78828D',
      height: '43px',
      padding: '0px',
      cursor: 'pointer',
      textAlign: 'left',
      fontWeight: 300,
      lineHeight: '21px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 16px',
      color: state.isSelected ? '#405BFF' : '#78828D',
      backgroundColor: state.isSelected ? '#D1D8FF' : state.isFocused ? '#F0F2FF' : 'transparent',
      fontWeight: state.isSelected ? 400 : 300,
      fontSize: '17px',
      lineHeight: '38px',
      textAlign: 'left',
      cursor: 'pointer',
      transition: 'background-color 0.15s ease',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0px 21px 0px 0px',
      color: state.isFocused ? '#405BFF' : '#405BFF',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (provided) => ({
      ...provided,
      animation: 'currency-menu-enter 0.18s cubic-bezier(0.16, 1, 0.3, 1) both',
      transformOrigin: 'top center',
    }),
  };

  const getForex = async (currency) => {
    try {
      const response = await axios.post(
        '/api/forex/get',
        { base_currency: "USD" },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data ? response.data.json : null;
      } else {
        console.error(`Request failed with status code: ${response.status}`);
        return null;
      }
    } catch (error) {
      if (error.response) {
        // Server responded with a status outside 2xx
        console.error(`API Error: ${error.response.status} - ${error.response.data.message || error.message}`);
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response from server. Please check your network.");
      } else {
        // Something else went wrong
        console.error("Error while setting up the request:", error.message);
      }
      return null;
    }
  };

  const handleCurrencyChange = async (option) => {
    try {
      setSelectedCurrency(option.value);
      setSelDashboardCurrency(option.value);

      const forex = await getForex(option.value);

      if (!forex) {
        console.error("Forex data is empty or failed to fetch.");
        return;
      }

      setSelectedForex(forex);
      await dispatch(setForex(forex));
      await dispatch(setDashboardCurrencyRx(option.value));

    } catch (error) {
      console.error("Error during currency change:", error.message);
    }
  };


  const user = useSelector(
    (state) => state.auth.user
  )
  // Use the React Query hook to fetch dashboard currency data
  const { data: dashboardCurrency = [], isLoading: isLoadingFetchCurrency } = useFetchDashboardCurrency(user.token);
  useEffect(() => {
    const handleLoading = async () => {
      try {
        await dispatch(setAppLoading(isLoadingFetchCurrency));
      } catch (error) {
        console.error("Error setting app loading state:", error.message);
      }
    };

    handleLoading();
  }, [isLoadingFetchCurrency, dispatch]);


  useEffect(() => {
    const updateDashboard = async () => {
      try {
        // Fetch Forex and dispatch dashboard updates concurrently
        const [forex] = await Promise.all([
          getForex('USD'),
          dispatch(setDashboardCurrencySum(dashboardCurrencySum)) // Dispatch currency sum
        ]);

        if (!forex) {
          console.warn("Forex data is empty or null");
          return;
        }

        // Set states after successful fetch
        setSelectedForex(forex);
        setSelectedCurrency(dashboradCurrency);
        setAllCurrency(dashboardCurrencySum);

        // Dispatch forex to Redux
        await dispatch(setForex(forex));
      } catch (error) {
        console.error("Error updating dashboard:", error);
      }
    };

    updateDashboard();
  }, [dashboardCurrencySum, dashboradCurrency, allCurrency, dispatch]);

  const handleClickOutsideDropdown = (event) => {
    try {
      if (!calendarRef || !calendarRef.current) {
        console.warn("calendarRef is not initialized.");
        return;
      }

      const isClickInsideCalendarDropdown = calendarRef.current.contains(event.target);

      if (!isClickInsideCalendarDropdown) {
        setShowCalendar(false);
      }
    } catch (error) {
      console.error("Error in handleClickOutsideDropdown:", error);
    }
  };

  useEffect(() => {
    const handleDropdownClick = () => {
      try {
        document.addEventListener('click', handleClickOutsideDropdown);
      } catch (error) {
        console.error("Error attaching dropdown click listener:", error);
      }
    };

    const initializeApp = () => {
      try {
        const appCurrency = global?.config?.appCurrency?.();
        if (!appCurrency) {
          console.warn("App currency is undefined or invalid.");
          return;
        }
        dispatch(setDashboardCurrencyRx(appCurrency));
      } catch (error) {
        console.error("Error initializing app currency:", error);
      }
    };

    // Execute initialization
    handleDropdownClick();
    initializeApp();

    // Cleanup
    return () => {
      try {
        document.removeEventListener('click', handleClickOutsideDropdown);
      } catch (error) {
        console.error("Error removing dropdown click listener:", error);
      }
    };
  }, [dispatch]);

  const options = dashboardCurrency.map((currency) => ({
    value: currency,
    label: `${getCurrencyByCode.code(currency).currency}`
  }));

  const formatOptionLabel = ({ value, label }) => {
    const symbol = new Intl.NumberFormat('en-US', { style: 'currency', currency: value }).format(0).replace(/[\d.,\s]/g, '');
    const symbolFontSize = symbol.length > 2 ? '10px' : symbol.length === 2 ? '12px' : '15px';
    return (
      <div className="currency-option">
        <span className="currency-symbol" style={{ fontSize: symbolFontSize }}>{symbol}</span>
        <span className="dropdown-text">{label}</span>
      </div>
    );
  };

  const sumAllCurrencies = async (val) => {
    try {
      setAllCurrency(val);

      const appCurrency = global?.config?.appCurrency?.();
      if (!appCurrency) {
        console.warn("App currency is undefined or invalid.");
        return; // Prevent further actions if currency is invalid
      }

      setSelectedCurrency(appCurrency);

      await dispatch(setDashboardCurrencyRx(appCurrency));
      await dispatch(setDashboardCurrencySum(val));
    } catch (error) {
      console.error("Error in sumAllCurrencies:", error);
    }
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
      {!isMobile ? (
        /* ========================================================================= */
        /* DESKTOP & TABLET VERSION (Intact original implementation, hidden on mobile) */
        /* ========================================================================= */
        <div className="curency-dropdown filter-dashbord-calendar desktop-dashboard-filter-view">
          <div className="curency-dropdown-inner">
            <div className="currency-title">{global.config.locate(appSettings && appSettings.language, 'Currency')}</div>
            {(dashboardCurrency && dashboardCurrency.length > 0) ? (
              <Select
                key={selectedCurrency ? selectedCurrency : "USD"}
                defaultValue={{ value: selectedCurrency ? selectedCurrency : "USD", label: getCurrencyByCode.code(selectedCurrency ? selectedCurrency : "USD").currency }}
                options={options}
                styles={customStyles}
                onChange={handleCurrencyChange}
                formatOptionLabel={dashboradCurrency && formatOptionLabel}
              />)
              :
              isLoadingFetchCurrency === true ?
                (() => {
                  const appCur = global?.config?.appCurrency?.() || "USD";
                  const appCurLabel = getCurrencyByCode.code(appCur)?.currency || "US Dollar";
                  return (
                    <Select
                      key={isLoadingFetchCurrency ? "loading" : "empty"}
                      defaultValue={{ value: appCur, label: appCurLabel }}
                      options={[]}
                      styles={customStyles}
                      isDisabled={true}
                      onChange={() => {}}
                    />
                  );
                })()
                :
                global.config.locate(appSettings && appSettings.language, 'No Invoices Generated in this Account')
            }
            {(dashboardCurrency && dashboardCurrency.length > 0) &&
              <p>{global.config.locate(appSettings && appSettings.language, 'Sum all Currencies')}<input type="checkbox" checked={allCurrency} name="allCurrency" value={allCurrency} onChange={async (e) => {
                sumAllCurrencies(!allCurrency); localStorage.setItem("allCur", !allCurrency);
                const forex = await getForex(appSettings && appSettings.currency);
                setSelectedForex(forex);
                await dispatch(setForex(forex));
                if (!allCurrency === true) {
                  await setDashboardCurrencyRx(global.config.appCurrency());
                  setSelectedCurrency(global.config.appCurrency());
                }
              }} /></p>
            }
          </div>
          <div className="date-picker-outer date-picker-outer-all" ref={calendarRef}>
            <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                className="rs-picker-toggle-caret rs-icon"
                aria-label="calendar"
                data-category="legacy"
              >
                <path d="M5 3V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V3H2.5C1.67157 3 1 3.67157 1 4.5V13.5C1 14.3284 1.67157 15 2.5 15H13.5C14.3284 15 15 14.3284 15 13.5V4.5C15 3.67157 14.3284 3 13.5 3H12V1.5C12 1.22386 11.7761 1 11.5 1C11.2239 1 11 1.22386 11 1.5V3H5ZM2 5H14V13.5C14 13.7761 13.7761 14 13.5 14H2.5C2.22386 14 2 13.7761 2 13.5V5ZM3 7H5V9H3V7ZM7 7H9V9H7V7ZM11 7H13V9H11V7ZM3 10H5V12H3V10ZM7 10H9V12H7V10ZM11 10H13V12H11V10Z"></path>
              </svg>
              <input
                type="text"
                value={
                  selectedRange ?
                    `${new Date(selectedRange[0]).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })} to ${new Date(selectedRange[1]).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}`
                    : ''
                }
                id="date-range"
                name="date-range"
                placeholder="All time"
                onClick={toggleCalendar}
                autoComplete="off"
                readOnly
              />
            </div>
            <div className="date-range-new right-align">
              {showCalendar &&
                <div className="calendar-popup-enter">
                  <Calendar onCancel={cancelCalendar} onChange={onDateChange} initialRange={{ startDate: selectedRange ? selectedRange[0] : null, endDate: selectedRange ? selectedRange[1] : null }} />
                </div>
              }
            </div>
          </div>
        </div>
      ) : (
        /* ========================================================================= */
        /* MOBILE-ONLY VERSION (Rendered only on mobile screens <= 767px)             */
        /* ========================================================================= */
        <div className="mobile-filter-calendar-wrapper">
          <div className="mobile-filter-title">{global.config.locate(appSettings && appSettings.language, 'Currency')}</div>
          <div className="mobile-filter-inputs-row">
            <div className="mobile-currency-select-container">
              {(dashboardCurrency && dashboardCurrency.length > 0) ? (
                <Select
                  key={selectedCurrency ? selectedCurrency : "USD"}
                  defaultValue={{ value: selectedCurrency ? selectedCurrency : "USD", label: getCurrencyByCode.code(selectedCurrency ? selectedCurrency : "USD").currency }}
                  options={options}
                  styles={customStyles}
                  onChange={handleCurrencyChange}
                  formatOptionLabel={dashboradCurrency && formatOptionLabel}
                  className="mobile-currency-select"
                />
              ) : (() => {
                  const appCur = global?.config?.appCurrency?.() || "USD";
                  const appCurLabel = getCurrencyByCode.code(appCur)?.currency || "US Dollar";
                  return (
                    <Select
                      key={isLoadingFetchCurrency ? "loading" : "empty"}
                      defaultValue={{ value: appCur, label: appCurLabel }}
                      options={[]}
                      styles={customStyles}
                      isDisabled={true}
                      onChange={() => {}}
                      className="mobile-currency-select"
                    />
                  );
                })()}
            </div>
            <div className="mobile-date-picker-container" ref={calendarRef}>
              <div className="mobile-date-picker-inner">
                <input
                  type="text"
                  value={
                    selectedRange ?
                      `${new Date(selectedRange[0]).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })} to ${new Date(selectedRange[1]).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}`
                      : ''
                  }
                  id="mobile-date-range"
                  name="mobile-date-range"
                  placeholder="All time"
                  onClick={toggleCalendar}
                  autoComplete="off"
                  readOnly
                />
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mobile-calendar-right-icon"
                  onClick={toggleCalendar}
                >
                  <path fillRule="evenodd" clipRule="evenodd" d="M18.5 2H15V0.5C15 0.2 14.8 0 14.5 0C14.2 0 14 0.2 14 0.5V2H5V0.5C5 0.2 4.8 0 4.5 0C4.2 0 4 0.2 4 0.5V2H0.5C0.2 2 0 2.2 0 2.5V18.5C0 18.8 0.2 19 0.5 19H18.5C18.6 19 18.6 19 18.7 19C18.9 18.9 19 18.7 19 18.5V2.5C19 2.2 18.8 2 18.5 2ZM18 18H1V7H18V18ZM18 6H1V3H4V4.5C4 4.8 4.2 5 4.5 5C4.8 5 5 4.8 5 4.5V3H14V4.5C14 4.8 14.2 5 14.5 5C14.8 5 15 4.8 15 4.5V3H18V6ZM5 10H4V11H5V10ZM15 10H14V11H15V10ZM13 10H12V11H13V10ZM7 10H6V11H7V10ZM11 10H10V11H11V10ZM9 10H8V11H9V10ZM5 12H4V13H5V12ZM15 12H14V13H15V12ZM13 12H12V13H13V12ZM7 12H6V13H7V12ZM11 12H10V13H11V12ZM9 12H8V13H9V12ZM5 14H4V15H5V14ZM15 14H14V15H15V14ZM13 14H12V15H13V14ZM7 14H6V15H7V14ZM11 14H10V15H11V14ZM9 14H8V15H9V14Z" fill="#405BFF"/>
                </svg>
              </div>
              {showCalendar && (
                <div className="mobile-calendar-popup date-range-new calendar-popup-enter">
                  <Calendar onCancel={cancelCalendar} onChange={onDateChange} initialRange={{ startDate: selectedRange ? selectedRange[0] : null, endDate: selectedRange ? selectedRange[1] : null }} />
                </div>
              )}
            </div>
          </div>
          <div className="mobile-sum-all-wrapper">
            <label className="mobile-sum-all-label">
              <input
                type="checkbox"
                checked={allCurrency}
                name="allCurrency"
                style={{ display: "none" }}
                disabled={isLoadingFetchCurrency || !(dashboardCurrency && dashboardCurrency.length > 0)}
                onChange={async (e) => {
                  sumAllCurrencies(!allCurrency);
                  localStorage.setItem("allCur", !allCurrency);
                  const forex = await getForex(appSettings && appSettings.currency);
                  setSelectedForex(forex);
                  await dispatch(setForex(forex));
                  if (!allCurrency === true) {
                    await setDashboardCurrencyRx(global.config.appCurrency());
                    setSelectedCurrency(global.config.appCurrency());
                  }
                }}
              />
              <span className="mobile-sum-all-text">{global.config.locate(appSettings && appSettings.language, 'Sum all Currencies')}</span>
              <span className={`mobile-sum-all-checkbox ${allCurrency ? 'checked' : ''}`}>
                {allCurrency ? (
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#405BFF" />
                    <path d="M6 10.2L8.8 13L14.5 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="9" stroke="#CBD5E1" strokeWidth="1.8" fill="white" />
                  </svg>
                )}
              </span>
            </label>
          </div>
        </div>
      )}
    </>
  );
}